import { memo } from "react";
import { ScreenMax } from "styles/antTheme/Variables";
import { useMediaQuery } from "usehooks-ts";

import { type DocumentInstanceType } from "types/enum";

import { BTIconPaperClipOutlined } from "commonComponents/btWrappers/BTIcon";
import { DocumentContextMenu } from "commonComponents/utilities/DocumentContextMenu/DocumentContextMenu";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";

import "./columnFiles.less";

interface IFilesResponse {
    entityId: number;
    entityType: DocumentInstanceType;
    docCount: number;
}

const FilesCell = memo(function FilesCell(props: IGridCellRenderProps<IFilesResponse>) {
    const { cellValue } = props;
    const isSmallScreen = useMediaQuery(`(max-width: ${ScreenMax.sm}px)`);

    if (!cellValue) {
        return null;
    }

    if (isSmallScreen) {
        if (cellValue.docCount === 0) {
            return null;
        }

        return (
            <span className="filesColumnLabel" data-testid="filesColumnLabel">
                <BTIconPaperClipOutlined />
                {cellValue.docCount}
            </span>
        );
    }

    return (
        <div className="filesColumn">
            <DocumentContextMenu {...cellValue} />
        </div>
    );
});

export const columnFiles: IClientGridColumn<IFilesResponse> = {
    columnType: GridColumnType.files,
    Cell: FilesCell,
};
